// extracted by mini-css-extract-plugin
export default {"warehouse":"warehouse_warehouse__lVwBH","dossierLabel":"warehouse_dossierLabel__rIYIz","fields":"warehouse_fields__uaLU9","fillingLabel":"warehouse_fillingLabel__-7MOV"};